import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], keyword: string, itemName: string): any {
    if (!items || !keyword) {
      return items;
    }

    return items.filter((item) => item[itemName].indexOf(keyword) !== -1);
  }
}
